import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

interface PrivateRouteProps {
  readonly children: React.ReactNode;
}

export function PrivateRoute({ children }: Readonly<PrivateRouteProps>) {
  const location = useLocation();
  const navigate = useNavigate();

  if (!localStorage.getItem("token")) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <div className="min-h-screen w-full bg-gray-50">
      <header className="bg-green-600 text-white py-6 px-8">
        <div className="max-w-7xl  flex justify-between items-center">
          <h1 className="text-2xl font-bold">Station Management Dashboard</h1>
          <div className="flex justify-start items-center gap-4">
            <Link to={"/admin/dashboard"}>Dashboard</Link>
            <Link to={"/admin/settings"}>Settings</Link>
            <Link to={"/admin/profile"}>Profile</Link>
            <button
              onClick={() => {
                localStorage.removeItem("token");
                navigate("/login");
              }}
              className="bg-white rounded-2xl w-[150px] text-green-600 flex items-center justify-center cursor-pointer py-2"
            >
              Logout
            </button>
          </div>
        </div>
      </header>
      {children}
    </div>
  );
}
